import { LTLAccessorial, QuoteFormStop } from '../../types';
import {
  BatchLTLBulkEditValues,
  BatchLTLShipmentInput,
  BatchLTLStackableEdit,
} from '../types';

// Applies the non-empty bulk edit values to one shipment.
export function applyBatchLTLBulkEdit(
  shipment: BatchLTLShipmentInput,
  values: BatchLTLBulkEditValues,
  accessorials: LTLAccessorial[]
): BatchLTLShipmentInput {
  const ltl = shipment.ltl ?? { selectedAccessorials: [] };
  const lastStopIndex = shipment.stops.length - 1;
  const stops = shipment.stops.map((stop, index) => {
    if (index === 0 && values.originLocation.trim()) {
      return withLocation(stop, values.originLocation);
    }

    if (index === lastStopIndex && values.destinationLocation.trim()) {
      return withLocation(stop, values.destinationLocation);
    }

    return stop;
  });

  const addedAccessorial = accessorials.find(
    (accessorial) => accessorial.code === values.addAccessorialCode
  );
  const isAlreadySelected = ltl.selectedAccessorials.some(
    (accessorial) => accessorial.code === addedAccessorial?.code
  );
  const selectedAccessorials = [
    ...ltl.selectedAccessorials,
    ...(addedAccessorial && !isAlreadySelected
      ? [
          {
            code: addedAccessorial.code,
            name: addedAccessorial.name,
            externalId: addedAccessorial.externalId,
          },
        ]
      : []),
  ].filter((accessorial) => accessorial.code !== values.removeAccessorialCode);

  const stackable =
    values.stackable === BatchLTLStackableEdit.Unchanged
      ? ltl.commodity?.stackable
      : values.stackable === BatchLTLStackableEdit.Stackable;

  return {
    ...shipment,
    stops,
    pickupDate: values.pickupDate ?? shipment.pickupDate,
    pickupCloseDate: values.pickupCloseDate ?? shipment.pickupCloseDate,
    ltl: {
      ...ltl,
      commodity: {
        ...ltl.commodity,
        freightClass: values.freightClass || ltl.commodity?.freightClass,
        stackable,
      },
      items: (ltl.items ?? []).map((item) =>
        values.freightClass
          ? { ...item, freightClass: values.freightClass }
          : item
      ),
      selectedAccessorials,
    },
  };
}

function withLocation(stop: QuoteFormStop, location: string): QuoteFormStop {
  return {
    ...stop,
    location: location.trim(),
    city: '',
    state: '',
    zip: '',
    addressName: '',
  };
}
